// extracted by extract-css-chunks-webpack-plugin
module.exports = {"map":"app-components-staticpages-blocks-mapblock--map"};